import { render, staticRenderFns } from "./LeccionC3.vue?vue&type=template&id=d52a7828&"
import script from "./LeccionC3.vue?vue&type=script&lang=js&"
export * from "./LeccionC3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports